import React from "react";

import { TextFit } from "@/common/TextFit";
import { ThumbsProps } from "@/containers/Thumbs";
import Svg from "@/styles/Svg";

import {
  FadeInText,
  Header,
  Main,
  ThankYou,
  ThumbDown,
  ThumbUp,
  ThumbVotes,
  ThumbWrapper,
  Title,
  TotalVotes,
  VoteWrapper,
} from "./styles";

const thumb: string = require("!svg-inline-loader!~assets/icons/thumb_bild_tv_app.svg");
const selectedThumb: string = require("!svg-inline-loader!~assets/icons/thumb_bild_tv_app_red.svg");

const BildTvAppThumbs: React.FC<ThumbsProps> = (
  props: ThumbsProps
): React.JSX.Element => {
  const {
    interaction,
    thumbsDownSelected,
    thumbsDownCount,
    thumbsUpCount,
    thumbsUpSelected,
    onVote,
  } = props;
  const totalVotes = thumbsUpCount + thumbsDownCount;
  const voted = thumbsUpSelected || thumbsDownSelected;

  return (
    <Main>
      <Header>
        <Title>
          <TextFit maxHeight={180} maxFontSize={40} text={interaction.title} />
        </Title>
        <TotalVotes>{`${totalVotes.toLocaleString()} Stimmen`}</TotalVotes>
      </Header>
      <VoteWrapper>
        <ThumbWrapper>
          <ThumbUp selected={thumbsUpSelected} onClick={() => onVote(true)}>
            <Svg contents={thumbsUpSelected ? selectedThumb : thumb} />
          </ThumbUp>
          <ThumbVotes>
            {voted && <FadeInText>{thumbsUpCount.toLocaleString()}</FadeInText>}
          </ThumbVotes>
        </ThumbWrapper>
        <ThumbWrapper>
          <ThumbDown
            selected={thumbsDownSelected}
            onClick={() => onVote(false)}
          >
            <Svg contents={thumbsDownSelected ? selectedThumb : thumb} />
          </ThumbDown>
          <ThumbVotes>
            {voted && (
              <FadeInText>{thumbsDownCount.toLocaleString()}</FadeInText>
            )}
          </ThumbVotes>
        </ThumbWrapper>
      </VoteWrapper>
      <ThankYou>
        {voted && (
          <FadeInText delay={800}>
            {interaction.thankYouText || "Danke! BILD - deine Stimme zählt!"}
          </FadeInText>
        )}
      </ThankYou>
    </Main>
  );
};

export default BildTvAppThumbs;
